// OIDC Configuration using environment variables
// All configuration is now driven by .env files (development, staging, production)
// See: .env, .env.development, .env.staging, .env.production

// Get configuration from environment variables with fallbacks for development
const authority = import.meta.env.VITE_AUTHORITY || 'https://localhost:44306';
const clientId = import.meta.env.VITE_CLIENT_ID || 'learnleaf_App';
const redirectUri = import.meta.env.VITE_REDIRECT_URI || 'http://localhost:3001/callback';
const postLogoutRedirectUri = import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI || 'http://localhost:3001';
const scope = import.meta.env.VITE_OIDC_SCOPE || 'openid profile email roles learnleaf';
const automaticSilentRenew = import.meta.env.VITE_AUTOMATIC_SILENT_RENEW !== 'false'; // Default true

export const oidcConfig = {
  authority,
  client_id: clientId,
  redirect_uri: redirectUri,
  post_logout_redirect_uri: postLogoutRedirectUri,
  response_type: 'code',
  // Request role claims from OpenIddict
  // Sprint 2.2: Role-based permissions
  // Note: Using 'roles' (plural) to match OpenIddict's standard scope
  scope,
  automaticSilentRenew,
  loadUserInfo: true,
  // For PWA: use redirect flow instead of popup
  // (popups don't work well on mobile)
  onSigninCallback: () => {
    // Remove OIDC params from URL after login
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
